var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.statusGraph
            ? _c(
                "graph-panel",
                {
                  attrs: {
                    graphTitle: _vm.$i18n.t("graph.statistics_by_status"),
                    periodes: ["lastDay", "lastWeek", "lastMonth", "lastYear"],
                    ibans: _vm.ibans,
                    contacts: _vm.contacts,
                    documentTypes: _vm.docTypes,
                    trueValueLabel: _vm.$i18n.t("graph.shw_amnt"),
                    falseValueLabel: _vm.$i18n.t("graph.shw_nmbr"),
                  },
                  on: {
                    "fetch-periode": function ($event) {
                      return _vm.fetchGraphStatus($event)
                    },
                    "filter-graph": function ($event) {
                      return _vm.filterStatus($event)
                    },
                    "clear-filter": function ($event) {
                      return _vm.clearFilterStatus()
                    },
                  },
                  model: {
                    value: _vm.showingStatus,
                    callback: function ($$v) {
                      _vm.showingStatus = $$v
                    },
                    expression: "showingStatus",
                  },
                },
                [
                  _c("graph-by-date-status", {
                    attrs: {
                      showAmountNotNumber: _vm.showingStatus,
                      chartData: _vm.statusGraph,
                      dates: _vm.dates,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }